import { render, staticRenderFns } from "./EntryWorks.vue?vue&type=template&id=79145daa&"
import script from "./EntryWorks.vue?vue&type=script&lang=js&"
export * from "./EntryWorks.vue?vue&type=script&lang=js&"
import style0 from "./EntryWorks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports